import {createRouter, createWebHistory} from "vue-router";
import DashboardIndex from "../components/tailwind_ui/components/DashboardIndex.vue";
import IndexTableComponent from "../components/tailwind_ui/components/QuestionSet/QuestionSetIndexComponents.vue";
import QuestionSetShowComponent from "../components/tailwind_ui/components/QuestionSet/QuestionSetShowComponent.vue";
import QuestionSetAuditorIndexComponent from "../components/tailwind_ui/components/QuestionSet/QuestionSetAuditorIndexComponent.vue";
import QuestionShowComponent from "../components/tailwind_ui/components/Question/QuestionShowComponent.vue";
import QuestionCheckpointCreateEditFormComponent from "../components/tailwind_ui/components/QuestionCheckpoint/QuestionCheckpointCreateEditFormComponent.vue";
import QuestionSectionIndexComponent from "../components/tailwind_ui/components/QuestionSection/QuestionSectionIndexComponent.vue";
import QuestionSectionShowComponent from "../components/tailwind_ui/components/QuestionSection/QuestionSectionShowComponent.vue";
import QuestionOptionsGroupIndexComponent from "../components/tailwind_ui/components/QuestionOptionsGroup/QuestionOptionsGroupIndexComponent.vue";
import QuestionOptionsGroupShowComponent from "../components/tailwind_ui/components/QuestionOptionsGroup/QuestionOptionsGroupShowComponent.vue";
import QuestionOptionsGroupCreateEditFormComponent from "../components/tailwind_ui/components/QuestionOptionsGroup/QuestionOptionsGroupCreateEditFormComponent.vue";
import QuestionOptionCreateEditFormComponent from "../components/tailwind_ui/components/QuestionOptionsGroup/QuestionOption/QuestionOptionCreateEditFormComponent.vue";
import QuestionSectionScoreContentCreateEditFormComponent from "../components/tailwind_ui/components/QuestionSection/ScoreContent/QuestionSectionScoreContentCreateEditFormComponent.vue";
import RegulatoryPermissionsComponent from "../components/tailwind_ui/components/Account/RegulatoryPermissionsComponent.vue";
import UserIndexComponent from "../components/tailwind_ui/components/User/UserIndexComponent.vue";
import UserShowComponent from "../components/tailwind_ui/components/User/UserShowComponent.vue";
import AccountIndexComponent from "../components/tailwind_ui/components/User/AccountIndexComponent.vue";
import AccountShowComponent from "../components/tailwind_ui/components/User/AccountShowComponent.vue";
import AccountGeneralQuestionsIndexComponent from "../components/tailwind_ui/components/User/AccountGeneralQuestionsIndexComponent.vue";
import MemberFirmIndexComponent from "../components/tailwind_ui/components/User/MemberFirmIndexComponent.vue";
import EmailTemplateIndexComponent from "../components/tailwind_ui/components/Email/EmailTemplateIndexComponent.vue";
import EmailTemplateShowComponent from "../components/tailwind_ui/components/Email/EmailTemplateShowComponent.vue";

const routes = [
    //--Question builder--
    {
        path: '/new',
        name: 'Dashboard',
        component: DashboardIndex,
    },
    {
        path: '/new/member-firm/question-set',
        name: 'QuestionSetIndex',
        component: IndexTableComponent,
    },
    {
        path: '/new/member-firm/question-set/show/:id',
        name: 'QuestionSetShow',
        component: QuestionSetShowComponent,
    },
    {
        path: '/new/member-firm/question-set/:question_set_id/question/show/:question_id',
        name: 'QuestionSetQuestionShow',
        component: QuestionShowComponent,
    },
    {
        path: '/new/member-firm/question-set/:question_set_id/question/:question_id/checkpoint/create',
        name: 'QuestionCheckpointCreate',
        component: QuestionCheckpointCreateEditFormComponent,
    },
    {
        path: '/new/member-firm/question-set/:question_set_id/question/:question_id/update/:id',
        name: 'QuestionCheckpointUpdate',
        component: QuestionCheckpointCreateEditFormComponent,
    },
    {
        path: '/new/member-firm/question-set/auditor-index/show/:question_set_id',
        name: 'QuestionSetAuditorIndex',
        component: QuestionSetAuditorIndexComponent,
    },

    //question section
    {
        path: '/new/member-firm/question-section',
        name: 'QuestionSectionIndex',
        component: QuestionSectionIndexComponent,
    },
    {
        path: '/new/member-firm/question-section/show/:id',
        name: 'QuestionSectionShow',
        component: QuestionSectionShowComponent,
    },

    //question options group
    {
        path: '/new/member-firm/question-options-group',
        name: 'QuestionOptionsGroupIndex',
        component: QuestionOptionsGroupIndexComponent,
    },
    // {
    //     path: '/new/member-firm/question-options-group/create',
    //     name: 'QuestionOptionsGroupCreate',
    //     component: QuestionOptionsGroupCreateEditFormComponent,
    // },
    // {
    //     path: '/new/member-firm/question-options-group/update/:id',
    //     name: 'QuestionOptionsGroupUpdate',
    //     component: QuestionOptionsGroupCreateEditFormComponent,
    // },
    {
        path: '/new/member-firm/question-options-group/show/:id',
        name: 'QuestionOptionsGroupShow',
        component: QuestionOptionsGroupShowComponent,
    },

    //question option
    // {
    //     path: '/new/member-firm/question-options-group/:question_options_group_id/question-option/create',
    //     name: 'QuestionOptionsGroupOptionCreate',
    //     component: QuestionOptionCreateEditFormComponent,
    // },
    // {
    //     path: '/new/member-firm/question-options-group/:question_options_group_id/question-option/update/:id',
    //     name: 'QuestionOptionsGroupOptionUpdate',
    //     component: QuestionOptionCreateEditFormComponent,
    // },

    //score content
    {
        path: '/new/member-firm/question-section/:question_section_id/score-content/create',
        name: 'QuestionSectionScoreContentCreate',
        component: QuestionSectionScoreContentCreateEditFormComponent,
    },
    {
        path: '/new/member-firm/question-section/:question_section_id/score-content/update/:id',
        name: 'QuestionSectionScoreContentUpdate',
        component: QuestionSectionScoreContentCreateEditFormComponent,
    },

    // User
    {
        path: '/new/member-firm/users',
        name: 'UserIndex',
        component: UserIndexComponent,
    },
    {
        path: '/new/member-firm/users/show/:id',
        name: 'UserShow',
        component: UserShowComponent,
    },

    //Email
    {
        path: '/new/member-firm/emails',
        name: 'EmailTemplateIndex',
        component: EmailTemplateIndexComponent,
    },
    {
        path: '/new/member-firm/emails/show/:id',
        name: 'EmailTemplateShow',
        component: EmailTemplateShowComponent,
    },

    // Account
    {
        path: '/new/member-firm/accounts',
        name: 'AccountIndex',
        component: AccountIndexComponent,
    },
    {
        path: '/new/member-firm/accounts/show/:id',
        name: 'AccountShow',
        component: AccountShowComponent,
    },
    {
        path: '/new/member-firm/accounts-general-questions',
        name: 'AccountGeneralQuestionsIndex',
        component: AccountGeneralQuestionsIndexComponent,
    },
    // Member Firms
    {
        path: '/new/member-firm',
        name: 'MemberFirmIndex',
        component: MemberFirmIndexComponent,
    },

    //--Account--
    {
        path: '/new-account/regulatory-permissions',
        name: 'RegulatoryPermissions',
        component: RegulatoryPermissionsComponent,
    },

    // Network member
    {
        path: '/new-member-firm/:account/regulatory-permissions',
        name: 'AccountRegulatoryPermissions',
        component: RegulatoryPermissionsComponent,
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

export default router;